import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import {
  fetchLines,
  fetchTrains,
  receiveLines,
  receiveTrainPosition,
  closeTrainModal,
} from '../actions'
import TrainInfoModal from '../components/train_positions/TrainInfoModal'

const mapStateToProps = state => {
  const { lines, trains, showingTrain } = state.trainPositionReducer
  const { themeName } = state.themeReducer

  return {
    lines,
    trains,
    showingTrain,
    themeName,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLines: async () => {
      try {
        const payload = await fetchLines()
        dispatch(receiveLines(payload))
      } catch (error) {
        showAlert('路線が取得できませんでした')
      }
    },
    fetchTrains: async () => {
      try {
        const payload = await fetchTrains()
        dispatch(receiveTrainPosition(payload))
      } catch (error) {
        showAlert('在線情報が取得できませんでした')
      }
    },
    closeTrainModal: () => {
      dispatch(closeTrainModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrainInfoModal)
